import React from 'react'
import { CircleIcon, SearchIcon } from '../constants/svgPath'
import { Link } from 'react-router-dom'

interface DropdownItem {
    label: string
    link: string
}

interface ButtonItem {
    label: string
    type?: 'dropdown' | 'button'
    items?: DropdownItem[]
    value?:object
}

interface MainSectionProps {
    title: string
    subtitle: string
    buttons?: any
    showSearch?: boolean
    onPress?:(props:any)=>void,
    selectedSection?:any
}

const MainSection: React.FC<MainSectionProps> = ({
    title,
    subtitle,
    buttons = [],
    showSearch = false,
    onPress=()=>{},
    selectedSection={}
}) => {

    
    return (
        <section className='case_sec'>
            <div className="contair case_inr">
                <div className="inner_hdg">
                    <h3><span><CircleIcon /></span>{title}</h3>
                    <h1>{subtitle}</h1>
                </div>

                <div className="case_list">
                    <div className="case_link case_link_scroll">
                        {buttons.map((btn:any, i:number) => (
                            <React.Fragment key={i}>
                                <button type="button" className={`btn_lst ${selectedSection?.label==btn?.label&&`btn_select`}`} onClick={()=>onPress(btn)}>
                                    {btn.label}
                                </button>

                                {/* Dropdown triggers for Healthcare OR AI Development */}

                            </React.Fragment>
                        ))}
                        {/* {buttons?.length > 4 && (
                            <details className='more_dropdown'>
                                <summary>More</summary>
                                <ul>
                                    {buttons?.slice(4)?.map((res:any) => {
                                        return (
                                            <li><Link to='' onClick={()=>onPress(res)}>{res?.label}</Link></li>
                                        )
                                    })}
                                </ul>
                            </details>
                        )} */}
                    </div>



                    {showSearch && (
                        <div className='case_inp'>
                            <input type="search" placeholder='Search Blog...' className='int_search' />
                            <button type="button" className='srch_btn'><SearchIcon /></button>
                        </div>
                    )}
                </div>
            </div>
        </section>
    )
}

export default MainSection